import {
  CreateFuelImportDto,
  UpdateFuelImportDto,
} from './../models/fuelImport/dto'
import axiosClient from './axiosClient'

const PATH = '/fuel-imports'

export const fuelImportApi = {
  getFuelImports: () =>
    axiosClient.get(PATH, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  createFuelImport: (fuelImport: CreateFuelImportDto) =>
    axiosClient.post(PATH, fuelImport, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  updateFuelImport: (id: number, fuelImport: UpdateFuelImportDto) =>
    axiosClient.put(`${PATH}/${id}`, fuelImport, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  deleteFuelImport: (id: number) =>
    axiosClient.delete(`${PATH}/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),
}
